module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "fabric",
    attrs: {
      "id": "_idContainer012"
    }
  }, [_c('h1', {
    staticClass: "Title",
    attrs: {
      "id": "_idParaDest-4"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor003"
    }
  }), _vm._v("Breads & Toppings")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer013"
    }
  }, [_c('h2', {
    staticClass: "Heading-1",
    attrs: {
      "id": "_idParaDest-5"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor004"
    }
  }), _vm._v("Sweet Potato Buttermilk Biscuits")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_vm._v("Makes 14 to 16 biscuits")]), _vm._v(" "), _c('p', {
    staticClass: "headnote"
  }, [_vm._v("This biscuit is on the sweeter side of regular biscuits. But who could resist using one of the south’s most popular vegetables—the sweet potato? ")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("2 cups self-rising flour ")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_c('span', {
    staticClass: "numerator"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "denom"
  }, [_vm._v("4")]), _vm._v(" teaspoon cinnamon")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_c('span', {
    staticClass: "numerator"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "denom"
  }, [_vm._v("4")]), _vm._v(" cup light brown sugar")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_c('span', {
    staticClass: "numerator"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "denom"
  }, [_vm._v("4")]), _vm._v(" cup unsalted butter, cut into "), _c('span', {
    staticClass: "numerator"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "denom"
  }, [_vm._v("2")]), _vm._v("-inch cubes and chilled")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_c('span', {
    staticClass: "numerator"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "denom"
  }, [_vm._v("4")]), _vm._v(" cup shortening, cut into "), _c('span', {
    staticClass: "numerator"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "denom"
  }, [_vm._v("2")]), _vm._v("-inch cubes and chilled")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("1 cup sweet potato purée or canned pumpkin")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_c('span', {
    staticClass: "numerator"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "denom"
  }, [_vm._v("2")]), _vm._v(" cup buttermilk")]), _vm._v(" "), _c('p', {
    staticClass: "direction"
  }, [_vm._v("Preheat oven to 425 degrees F. Prepare a baking sheet or 12-inch cast iron skillet with a light spray of nonstick cooking spray.")]), _vm._v(" "), _c('p', {
    staticClass: "direction"
  }, [_vm._v("Into the bowl of a food processor fitted with the dough blade, add flour, cinnamon, and sugar and stir together. Add butter and shortening and pulse just until the butter pieces are about the size of small peas (5–7 pulses). ")]), _vm._v(" "), _c('p', {
    staticClass: "direction"
  }, [_vm._v("Pour into a large bowl, make a well in the center of the flour, and add sweet potato purée and buttermilk to the well. Using a spatula, or your fingers, in a circular motion, fold the flour into wet mixture. Mix just enough until a dough ball forms. Do not overmix. Turn dough out onto a clean, floured surface. ")]), _vm._v(" "), _c('p', {
    staticClass: "direction"
  }, [_vm._v("Using floured hands, pat dough into a round disk about "), _c('span', {
    staticClass: "numerator"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "denom"
  }, [_vm._v("2")]), _vm._v("-thick and fold in half. Repeat this step 2 more times. (Keep the surface floured.) Then pat dough into a disk "), _c('span', {
    staticClass: "numerator"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "denom"
  }, [_vm._v("2")]), _vm._v(" inch thick for normal biscuits or "), _c('span', {
    staticClass: "numerator"
  }, [_vm._v("3")]), _vm._v("/"), _c('span', {
    staticClass: "denom"
  }, [_vm._v("4")]), _vm._v(" inch for tall biscuits. Using a 2-inch biscuit cutter dipped into flour, cut out biscuits starting at the outside of the dough and working your way to the center. Combine leftover scraps to form additional biscuits. Place cut biscuits onto baking sheet or in cast iron skillet, and bake for 10–15 minutes until lightly brown. Serve hot.")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer014"
    }
  }, [_c('h2', {
    staticClass: "Heading-1",
    attrs: {
      "id": "_idParaDest-6"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor005"
    }
  }), _vm._v("Ramp Buttermilk Biscuits")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_vm._v("Makes 10 to 12 biscuits")]), _vm._v(" "), _c('p', {
    staticClass: "headnote"
  }, [_vm._v("Southerners know biscuits, and what they are most emphatic about are buttermilk biscuits! Pair them with some gravy and you’ve got a match made in heaven. Ramps are wild onions found mostly in the Southeast and along the eastern coastline. Sometimes called spring onions, wild leeks, or wild garlic, ramps closely resemble scallions, with a white bulb and leafy stalk. If unable to source ramps in your area, substitute leeks, scallions, or chives.")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("2 cups self-rising flour")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_c('span', {
    staticClass: "numerator"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "denom"
  }, [_vm._v("4")]), _vm._v(" cup unsalted butter, cubed and chilled")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_c('span', {
    staticClass: "numerator"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "denom"
  }, [_vm._v("4")]), _vm._v(" cup shortening, cubed and chilled")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_c('span', {
    staticClass: "numerator"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "denom"
  }, [_vm._v("2")]), _vm._v(" cup chopped ramps")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("1 cup buttermilk")]), _vm._v(" "), _c('p', {
    staticClass: "direction"
  }, [_vm._v("Preheat oven to 425 degrees F. Prepare a baking sheet with a light spray of nonstick cooking spray.")]), _vm._v(" "), _c('p', {
    staticClass: "direction"
  }, [_vm._v("Measure flour into a large mixing bowl and, using a pastry cutter, 2 knives, or your clean hands, cut in butter and shortening until it resembles small peas. Or if you are using a food processor, pulse a few times until the consistency is achieved. ")]), _vm._v(" "), _c('p', {
    staticClass: "direction"
  }, [_vm._v("Evenly distribute the ramps over the flour mixture and, using a spatula, add in buttermilk and mix just until combined. Do not overmix the dough. Turn the dough onto a floured cutting board or countertop. Using floured hands, gently pat (do not use a rolling pin) the dough until it is "), _c('span', {
    staticClass: "numerator"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "denom"
  }, [_vm._v("2")]), _vm._v(" inch thick. Fold in half and pat down again and repeat 1 more time.")]), _vm._v(" "), _c('p', {
    staticClass: "direction"
  }, [_vm._v("Use a 2-inch round cookie cutter or biscuit cutter to cut dough into rounds and place onto baking sheet. If you like soft sides, place biscuits touching each other. If you like crusty sides, place them about 1 inch apart. They will not rise as high as the biscuits placed close together. Bake 10–15 minutes until golden brown. Serve hot.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer015"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-4",
    attrs: {
      "alt": "Photo of the recipe above.",
      "src": "image/Brunch-Biscuits-2-1.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer016"
    }
  }, [_c('h2', {
    staticClass: "Heading-1",
    attrs: {
      "id": "_idParaDest-7"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor006"
    }
  }), _vm._v("Panettone Grand Marnier French Toast")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_vm._v("Serves 6 to 8")]), _vm._v(" "), _c('p', {
    staticClass: "headnote"
  }, [_vm._v("Panettone is an Italian sweetbread loaf, similar to an American fruitcake, but a lot lighter, less sweet, and less dense in texture. It is good toasted with butter and a minimal amount of jam for a light breakfast snack or sliced thick and used to make a delicious fruit and nut-filled French toast. It is widely sold in supermarkets and specialty food outlets starting in the fall through New Year’s and during Easter. This dish is a special brunch choice and treat during the holiday season. Panettone would also be an excellent choice used in a holiday bread pudding.")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("4 large eggs")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("1 cup heavy cream")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("1 tablespoon sugar")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_c('span', {
    staticClass: "numerator"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "denom"
  }, [_vm._v("4")]), _vm._v(" cup Grand Marnier")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("1 teaspoon orange zest")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_c('span', {
    staticClass: "numerator"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "denom"
  }, [_vm._v("2")]), _vm._v(" teaspoon ground cardamom")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("1 teaspoon vanilla or almond extract")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("Pinch of kosher salt")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("1 loaf panettone, sliced crossways into 1-inch slices ")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("Unsalted butter for griddle, plus additional")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("Assorted fresh-cut berries, optional")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("Whipped cream, for garnish")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("Powdered sugar, for garnish")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("Syrup, of choice")]), _vm._v(" "), _c('p', {
    staticClass: "direction"
  }, [_vm._v("Whisk together eggs, cream, sugar, Grand Marnier, orange zest, cardamom, vanilla, and salt. Pour into a shallow dish. Dip the panettone slices in the mixture and place on a flat dish. Let rest for 15 minutes until the egg mixture is absorbed. ")]), _vm._v(" "), _c('p', {
    staticClass: "direction"
  }, [_vm._v("Preheat oven to 200 degrees F. Heat griddle over medium heat, and melt 2 tablespoons butter. Working in batches, add 3 to 4 slices of batter-soaked bread to griddle and cook until brown on both sides. Keep adding butter as needed. Move cooked toast to a baking sheet and keep warm in oven. Repeat until all slices are cooked. ")]), _vm._v(" "), _c('p', {
    staticClass: "direction"
  }, [_vm._v("To serve, transfer to serving plates, add fruit, whipped cream, and garnish with powdered sugar. Add butter and syrup as needed.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer017"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-4",
    attrs: {
      "alt": "Photo of the recipe above.",
      "src": "image/Brunch-Panettone_French_Toast-49-Edit-C2.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer018"
    }
  }, [_c('h2', {
    staticClass: "Heading-1",
    attrs: {
      "id": "_idParaDest-8"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor007"
    }
  }), _vm._v("Hot Cross Buns")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_vm._v("Makes 12 to 14 buns")]), _vm._v(" "), _c('h4', {
    staticClass: "Heading-3"
  }, [_vm._v("Dough")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_c('span', {
    staticClass: "numerator"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "denom"
  }, [_vm._v("4")]), _vm._v(" cup apple juice")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_c('span', {
    staticClass: "numerator"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "denom"
  }, [_vm._v("2")]), _vm._v(" cup dried fruit, of choice ")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_c('span', {
    staticClass: "numerator"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "denom"
  }, [_vm._v("2")]), _vm._v(" cup raisins or dried currants")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("1 "), _c('span', {
    staticClass: "numerator"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "denom"
  }, [_vm._v("4")]), _vm._v(" cups milk, room temperature")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("2 large eggs, room temperature")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("1 egg yolk, reserve white")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("6 tablespoons unsalted butter, room temperature")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("2 teaspoons instant yeast*")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_c('span', {
    staticClass: "numerator"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "denom"
  }, [_vm._v("4")]), _vm._v(" cup firmly packed light brown sugar ")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("1 teaspoon ground cardamom")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_c('span', {
    staticClass: "numerator"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "denom"
  }, [_vm._v("4")]), _vm._v(" teaspoon ground cinnamon")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_c('span', {
    staticClass: "numerator"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "denom"
  }, [_vm._v("4")]), _vm._v(" teaspoon ground cloves")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("1 "), _c('span', {
    staticClass: "numerator"
  }, [_vm._v("3")]), _vm._v("/"), _c('span', {
    staticClass: "denom"
  }, [_vm._v("4")]), _vm._v(" teaspoons kosher salt")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("1 tablespoon baking powder")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("4 "), _c('span', {
    staticClass: "numerator"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "denom"
  }, [_vm._v("2")]), _vm._v(" cups all-purpose flour")]), _vm._v(" "), _c('h4', {
    staticClass: "Heading-3"
  }, [_vm._v("Topping")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("1 reserved egg white")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("1 tablespoon milk")]), _vm._v(" "), _c('h4', {
    staticClass: "Heading-3"
  }, [_vm._v("Icing")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("1 cup plus 2 tablespoons powdered sugar")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_c('span', {
    staticClass: "numerator"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "denom"
  }, [_vm._v("2")]), _vm._v(" teaspoon vanilla extract")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("Pinch of kosher salt")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("4 teaspoons milk, more if needed")]), _vm._v(" "), _c('p', {
    staticClass: "headnote"
  }, [_vm._v("Hot Cross Buns are an Easter brunch tradition! Made with a rich yeast dough containing a variety of fruits and warming spices, they are marked on top with a cross, either cut into the dough or with strips of pastry or piped with a thick icing. Either way you finish them, your family is sure to enjoy them as they are reminded of the nursery rhyme that inspired this sweet treat.")]), _vm._v(" "), _c('p', {
    staticClass: "headnote"
  }, [_vm._v("“Hot Cross Buns! Hot Cross Buns!"), _c('br'), _vm._v("One a penny, two a penny, Hot Cross Buns!"), _c('br'), _vm._v("If you have no daughters, give them to your sons,"), _c('br'), _vm._v("One a penny, two a penny, Hot Cross Buns!")]), _vm._v(" "), _c('p', {
    staticClass: "direction"
  }, [_vm._v("In a medium bowl, mix together apple juice with the dried fruit and raisins. Cover with plastic wrap and microwave briefly, just until the fruit and liquid are very warm, about 1 minute. Set aside to cool to room temperature. In the bowl of a stand mixer using the dough hook, mix together milk, eggs, egg yolk, butter, yeast, sugar, spices, salt, baking powder, and flour; knead until the dough is soft and elastic (check manufacturer’s instructions for setting). Mix in the cooled fruit and any liquid left in the bowl. Cover the bowl with a clean dish towel and let the dough rise for 1 hour. It should become puffy, though may not double in bulk.")]), _vm._v(" "), _c('p', {
    staticClass: "direction"
  }, [_vm._v("*Not to be confused with dry active yeast. Instant yeast is mixed in with all of the other dry ingredients and does not require proofing (mixing with water).")]), _vm._v(" "), _c('p', {
    staticClass: "direction"
  }, [_vm._v("Lightly spray a 10-inch square pan or 9 x 13-inch pan with cooking spray. Using a 3–4 ounce muffin scoop, divide the dough into 12–14 billiard ball-size pieces. Use clean, greased hands to round them into balls. Arrange them in the prepared pan.")]), _vm._v(" "), _c('p', {
    staticClass: "direction"
  }, [_vm._v("Cover the pan, and let the buns rise for 1 hour, or until they’ve puffed up and are touching one another. ")]), _vm._v(" "), _c('p', {
    staticClass: "direction"
  }, [_vm._v("While the dough is rising, preheat the oven to 375 degrees F. In a small bowl, whisk together the egg white and milk, and brush over the buns, just before putting in the oven. Bake the buns for 20 minutes until golden brown. Remove from the oven and transfer to a wire rack.")]), _vm._v(" "), _c('p', {
    staticClass: "direction"
  }, [_vm._v("In a medium bowl, mix together powdered sugar, vanilla, salt, and milk into a thick icing and place in a piping bag or a small plastic ziptop bag with corner cut off to make an opening. When buns are completely cool, pipe a cross on top of each bun. Let rest until icing is set.")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer019"
    }
  }, [_c('h2', {
    staticClass: "Heading-1",
    attrs: {
      "id": "_idParaDest-9"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor008"
    }
  }), _vm._v("Brisket-Stuffed Herb Cornbread")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_vm._v("Serves approximately 12")]), _vm._v(" "), _c('p', {
    staticClass: "headnote"
  }, [_vm._v("This takes the sandwich to a new height! A meat and bread option that requires no assembly—it comes out of the oven ready to enjoy. Wrap a few chunks in some plastic wrap and throw into a backpack along with a bottle of wine for an impromptu picnic brunch. The best of both worlds—cornbread and slow-roasted brisket. Does it get any better than this? Make it in a skillet and slice or in an oversize muffin tin as individual special treats.")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("1 cup cornmeal")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("1 cup all-purpose flour")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_c('span', {
    staticClass: "numerator"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "denom"
  }, [_vm._v("2")]), _vm._v(" tablespoon baking powder")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_c('span', {
    staticClass: "numerator"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "denom"
  }, [_vm._v("2")]), _vm._v(" teaspoon baking soda")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("2 tablespoons sugar")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_c('span', {
    staticClass: "numerator"
  }, [_vm._v("3")]), _vm._v("/"), _c('span', {
    staticClass: "denom"
  }, [_vm._v("4")]), _vm._v(" teaspoon kosher salt")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("2 large eggs")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("1 cup buttermilk ")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("1 tablespoon chopped fresh thyme leaves")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("1 teaspoon chopped fresh rosemary")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("2 tablespoons vegetable oil")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("1 to 2 cups chopped "), _c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D11#_idTextAnchor085"
    }
  }, [_c('span', {
    staticClass: "Link"
  }, [_vm._v("Slow-Roasted Beef Brisket")])])]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("1 cup grated cheese, Gruyère or white cheddar")]), _vm._v(" "), _c('p', {
    staticClass: "direction"
  }, [_vm._v("Preheat oven to 400 degrees F. Prepare a 9- or 10-inch cast iron skillet with nonstick cooking spray.")]), _vm._v(" "), _c('p', {
    staticClass: "direction"
  }, [_vm._v(" In a large bowl, combine cornmeal, flour, baking powder, baking soda, sugar, and salt. In a medium bowl, whisk together eggs, buttermilk, herbs, and oil. Add to dry ingredients and mix well.")]), _vm._v(" "), _c('p', {
    staticClass: "direction"
  }, [_vm._v("Pour half of batter into the skillet and spread evenly. Cover with brisket and grated cheese; add remaining batter on top. Bake for 25–30 minutes or until a cake tester, inserted into the thickest part of the cornbread, comes out clean. Let rest 10–15 minutes before slicing.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer020"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-4",
    attrs: {
      "alt": "Photo of the recipe above.",
      "src": "image/Brunch-Brisket_Stuffed_Cornbread-2-2-Edit-C.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer021"
    }
  }, [_c('h2', {
    staticClass: "Heading-1",
    attrs: {
      "id": "_idParaDest-10"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor009"
    }
  }), _vm._v("Rum, Date, and Walnut Bread")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_vm._v("Makes 1 (9-inch) loaf")]), _vm._v(" "), _c('p', {
    staticClass: "headnote"
  }, [_vm._v("This quick bread is versatile enough to be served as a mini breakfast with a smear of flavored butter or as a full-blown brunch accompaniment. It is equally as good as a dinner dessert with a scoop of ice cream on top. ")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("1 cup chopped pitted dates ")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("4 tablespoons rum, divided")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("2 cups all-purpose flour")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_c('span', {
    staticClass: "numerator"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "denom"
  }, [_vm._v("2")]), _vm._v(" teaspoon baking powder")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_c('span', {
    staticClass: "numerator"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "denom"
  }, [_vm._v("2")]), _vm._v(" teaspoon baking soda")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_c('span', {
    staticClass: "numerator"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "denom"
  }, [_vm._v("2")]), _vm._v(" teaspoon kosher salt")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_c('span', {
    staticClass: "numerator"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "denom"
  }, [_vm._v("2")]), _vm._v(" cup sugar")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_c('span', {
    staticClass: "numerator"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "denom"
  }, [_vm._v("2")]), _vm._v(" cup brown sugar")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("2 large eggs, room temperature")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("2 tablespoons vegetable oil")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_c('span', {
    staticClass: "numerator"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "denom"
  }, [_vm._v("2")]), _vm._v(" cup plain Greek yogurt")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("1 cup chopped toasted walnut halves")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D5#_idTextAnchor016"
    }
  }, [_c('span', {
    staticClass: "Link"
  }, [_vm._v("Honey Butter")])])]), _vm._v(" "), _c('p', {
    staticClass: "direction"
  }, [_vm._v("Preheat oven to 350 degrees F. Prepare a 9 x 5-inch loaf pan with nonstick cooking spray. ")]), _vm._v(" "), _c('p', {
    staticClass: "direction"
  }, [_vm._v("In a medium bowl, soak dates in 2 tablespoons rum, stirring occasionally, for 30 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "direction"
  }, [_vm._v("In a large bowl, combine flour, baking powder, baking soda, salt, and sugars. In medium bowl, whisk eggs, oil, remaining rum, and yogurt. Stir wet ingredients into dry and mix thoroughly. Add dates and nuts and stir just to combine. ")]), _vm._v(" "), _c('p', {
    staticClass: "direction"
  }, [_vm._v("Pour batter into prepared pan and bake for 60 minutes or until a cake tester, inserted into the middle, comes out clean. Remove from oven and cool in pan for 10 minutes. Remove from pan and cool completely on a wire rack before serving with Honey Butter. ")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer022"
    }
  }, [_c('h2', {
    staticClass: "Heading-1",
    attrs: {
      "id": "_idParaDest-11"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor010"
    }
  }), _vm._v("Garlic-Infused Olive Oil ")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_vm._v("Makes 1 pint (2 cups)")]), _vm._v(" "), _c('p', {
    staticClass: "headnote"
  }, [_vm._v("Garlic-Infused Olive Oil is a timesaver in the kitchen and so easy to make. No more bits of minced garlic to bite into in your homemade salad dressings or on your roasted veggies. Basically, use in any recipe requiring both garlic and olive oil—which there are many. This will become a staple in your kitchen!")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("1 large head garlic, peeled")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("1 pint extra virgin olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "direction"
  }, [_vm._v("In a medium saucepan over medium-low heat, add garlic and oil. Let simmer slowly for 20–30 minutes. Remove from heat and cool to room temperature. ")]), _vm._v(" "), _c('p', {
    staticClass: "direction"
  }, [_vm._v("In the meantime, sterilize storage jar in a 275-degree oven for 20 minutes. When olive oil is cool, strain into jar and seal. Oil will last 2–3 months in the refrigerator. Be sure to properly label and date before storing.")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer023"
    }
  }, [_c('h2', {
    staticClass: "Heading-1",
    attrs: {
      "id": "_idParaDest-12"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor011"
    }
  }), _vm._v("Quince Jam")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_vm._v("Makes 5 half-pint (8-ounce) jars")]), _vm._v(" "), _c('p', {
    staticClass: "headnote"
  }, [_vm._v("Quince is a fruit that closely resembles a cross between an apple and a pear. Although never eaten raw, when cooked, quince takes on a rosy color and has an alluring aroma, reminiscent of pineapple and guava. Once the cornerstone of most country vegetable gardens, quince is now not as widely available, except in the fall. ")]), _vm._v(" "), _c('p', {
    staticClass: "headnote"
  }, [_vm._v("Quince is used to make jams, tarts, and preserves, and is a popular ingredient in Middle Eastern cuisine. In Latin countries, it is made into a paste called "), _c('em', {
    staticClass: "Headnote-emphasis CharOverride-3"
  }, [_vm._v("membrillo")]), _vm._v(", which is a welcomed addition to cheese and charcuterie platters. The Portuguese word for quince is "), _c('em', {
    staticClass: "Headnote-emphasis CharOverride-3"
  }, [_vm._v("marmelo,")]), _vm._v(" which has evolved into the word marmalade and is associated with very delicious citrusy fruit preserves. ")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("5 cups water")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("6 cups unpeeled grated quince or equal parts Bartlett pears and Golden Delicious apples")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_c('span', {
    staticClass: "numerator"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "denom"
  }, [_vm._v("3")]), _vm._v(" cup fresh-squeezed lemon juice")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("1 "), _c('span', {
    staticClass: "numerator"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "denom"
  }, [_vm._v("2")]), _vm._v(" tablespoons lemon zest")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("5 cups sugar")]), _vm._v(" "), _c('p', {
    staticClass: "direction"
  }, [_vm._v("Preheat oven to 200 degrees F. Place clean jars on a baking sheet and place in oven for 10 minutes to sterilize. Put seals and rings in a pot of boiling water for 10 minutes; leave in water until ready to cap jars.")]), _vm._v(" "), _c('p', {
    staticClass: "direction"
  }, [_vm._v("Place 5 cups water in a large Dutch oven or heavy-bottom saucepan and bring to a boil over medium heat. Add the quince, lemon juice, and lemon zest. Cook until quince is soft, about 10 minutes. Add sugar, stir to dissolve, and bring to a boil. Lower heat to medium low. Cook, uncovered, stirring occasionally until the jam turns pink and thickens to desired consistency, about 40 minutes. The mixture may seem too liquid, but it will thicken as it ages in the jar.")]), _vm._v(" "), _c('p', {
    staticClass: "direction"
  }, [_vm._v("Using a funnel and ladle, fill sterilized canning jars with the jam—leaving "), _c('span', {
    staticClass: "numerator"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "denom"
  }, [_vm._v("2")]), _vm._v("-inch headspace at the top. Wipe the jar rims clean of any overspill, using a clean damp cloth. Apply the lids and rings and turn jars upside down on a kitchen towel to cool.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer024"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-4",
    attrs: {
      "alt": "Photo of the recipe above.",
      "src": "image/Brunch-Quince_Jam-12.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer025"
    }
  }, [_c('h2', {
    staticClass: "Heading-1",
    attrs: {
      "id": "_idParaDest-13"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor012"
    }
  }), _vm._v("Easy Meyer Lemon Marmalade")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_vm._v("Makes 6 to 8 ("), _c('span', {
    staticClass: "numerator cap"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "denom"
  }, [_vm._v("2")]), _vm._v("-pint) jars")]), _vm._v(" "), _c('p', {
    staticClass: "headnote"
  }, [_vm._v("Marmalade is a jam made with citrus. And because the entire fruit is used, except the seeds, it produces its own pectin, making the addition of commercial pectin unnecessary. Slather it onto your toast, scones, or favorite breads. It can even be used on desserts, meats, and vegetables.")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("5 cups water")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("8 Meyer lemons ")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("5 cups sugar")]), _vm._v(" "), _c('p', {
    staticClass: "direction"
  }, [_vm._v("Preheat oven to 225 degrees F. Set clean jars on a baking sheet and place in oven for 10 minutes to sterilize. Put seals and rings in a pot of boiling water for 10 minutes; leave in water until ready to cap jars.")]), _vm._v(" "), _c('p', {
    staticClass: "direction"
  }, [_vm._v("Trim "), _c('span', {
    staticClass: "numerator"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "denom"
  }, [_vm._v("4")]), _vm._v("-inch off each end of the lemons. Cut each lemon in half and then into quarters. Remove seeds and excess membrane and save. Slice each quarter into thin slices. Combine the seeds, membrane, and ends in a cheesecloth bag or large piece of cheesecloth to form a pectin bag big enough to tie to the pot handle and drop over into the cooking fruit.")]), _vm._v(" "), _c('p', {
    staticClass: "direction"
  }, [_vm._v("In a very large pot over medium heat, add water and bring lemons and pectin bag to a boil. Let boil, uncovered, 30–45 minutes until fruit is soft. If fruit starts to stick to the bottom of pot add a little water. Stir in sugar, lower heat to medium, and boil, stirring occasionally. If foam forms, stir with a wooden spoon to bring the foam back down. Let cook for 20–25 minutes until the temperature, when taken with a candy thermometer, reaches 218–220 degrees. Another way to test is to drop a spoonful on a chilled saucer. If it gels, it is ready.")]), _vm._v(" "), _c('p', {
    staticClass: "direction"
  }, [_vm._v("Remove marmalade from heat and skim off any foam. Discard the pectin bag. Immediately fill the hot sterilized jars with cooked marmalade. Make sure to stir the marmalade as you go so the fruit remains evenly distributed. Leave a "), _c('span', {
    staticClass: "numerator"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "denom"
  }, [_vm._v("2")]), _vm._v("-inch headspace in the jars; apply the seals and rings and wipe clean.")]), _vm._v(" "), _c('p', {
    staticClass: "direction"
  }, [_vm._v("For the next step, if you do not have a canning pan with a canning rack insert, use a large Dutch oven or saucepan with a makeshift rack. This can be a small cake cooling rack that will fit inside the pan or a folded kitchen towel. Just make sure the jars do not sit directly on the bottom of the pan. ")]), _vm._v(" "), _c('p', {
    staticClass: "direction"
  }, [_vm._v("Heat water in the pan you are using until boiling and totally immerse jars (covered with 1-inch water) for 10 minutes and then remove to a dry kitchen towel. Leave jars undisturbed for at least 12 hours before checking the seals. (You may occasionally hear popping sounds; that is the sound of the jars sealing.) Holding jars at eye level, if the top center of the jar is slightly depressed, the jar is properly sealed—if slightly raised, it is not properly sealed. Sealed jars will store up to 1 year. Unsealed jars should be refrigerated and consumed within a week.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer026"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-4",
    attrs: {
      "alt": "Photo of the recipe above.",
      "src": "image/Brunch-Meyer_Marmalade-67-C.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer027"
    }
  }, [_c('h2', {
    staticClass: "Heading-1",
    attrs: {
      "id": "_idParaDest-14"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor013"
    }
  }), _vm._v("Hot Curried Peaches")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_vm._v("Serves 6 to 8")]), _vm._v(" "), _c('p', {
    staticClass: "headnote"
  }, [_vm._v("This versatile dish works for breakfast or brunch served over pancakes or for dessert atop a big scoop of vanilla ice cream or slice of pound cake. You can even serve it as a side with grilled pork chops or chicken. This recipe can easily be made using canned or frozen peaches if fresh are not available.")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("6 medium peaches, peeled and sliced")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("1 cup dried cherries or cranberries")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("5 tablespoons unsalted butter")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_c('span', {
    staticClass: "numerator"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "denom"
  }, [_vm._v("2")]), _vm._v(" cup packed light brown sugar")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("2 teaspoons curry powder")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("1 "), _c('span', {
    staticClass: "numerator"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "denom"
  }, [_vm._v("2")]), _vm._v(" teaspoons Chef Belinda Moroccan Blend or cinnamon")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("Pinch of kosher salt")]), _vm._v(" "), _c('p', {
    staticClass: "direction"
  }, [_vm._v("Preheat oven to 325 degrees F. Place peaches and cherries in a 9 x 9-inch baking dish. ")]), _vm._v(" "), _c('p', {
    staticClass: "direction"
  }, [_vm._v("In a small saucepan over medium-low heat (or in the microwave), melt butter. Remove from heat and stir in sugar, curry powder, spice blend, and salt. Spoon over fruit. Bake 45–60 minutes, or until peaches are soft and syrupy.")]), _vm._v(" "), _c('p', {
    staticClass: "direction"
  }, [_vm._v("This can be made ahead. Reheat in 350-degree oven for 30 minutes.")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer028"
    }
  }, [_c('h2', {
    staticClass: "Heading-1",
    attrs: {
      "id": "_idParaDest-15"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor014"
    }
  }), _vm._v("Homemade Sweet and Savory Bourbon Syrup")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_vm._v("Makes approximately 1 cup")]), _vm._v(" "), _c('p', {
    staticClass: "headnote"
  }, [_vm._v("This quick and easy syrup takes only 10 minutes to make. Use it on pancakes, waffles, ice cream, pound cake, and any number of other savory and sweet options. Feel free to substitute vanilla or maple extract for the bourbon, if appropriate for your family. Refrigerate any unused portion and reheat in the microwave before serving.")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("2 cups packed light brown sugar")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("1 cup water")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("1 tablespoon plus 1 teaspoon bourbon")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("1 teaspoon vanilla or maple extract if substituting for bourbon")]), _vm._v(" "), _c('p', {
    staticClass: "direction"
  }, [_vm._v("In a medium saucepan over medium heat, combine sugar and water. Cook until liquid starts to boil. Reduce heat to medium low and cook for 2 minutes, constantly stirring. Carefully add bourbon. Cook an additional 3 minutes then let cool slightly. ")]), _vm._v(" "), _c('p', {
    staticClass: "direction"
  }, [_vm._v("Pour into a sealable jar. Store in a cool dry area or refrigerate. Will last up to 30 days. Syrup will thicken as it cools. Reheat in microwave for 30–40 seconds before serving. Watch closely when reheating to prevent overspill in microwave.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer029"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-4",
    attrs: {
      "alt": "Photo of the recipe above.",
      "src": "image/Brunch-Syrup-55-Edit-C.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer030"
    }
  }, [_c('h2', {
    staticClass: "Heading-1",
    attrs: {
      "id": "_idParaDest-16"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor015"
    }
  }), _vm._v("Flavored Butters")]), _vm._v(" "), _c('p', {
    staticClass: "headnote"
  }, [_vm._v("Flavored butters provide an extra flavor boost to breads, meats, and sauces.")]), _vm._v(" "), _c('h3', {
    staticClass: "Heading-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor016"
    }
  }), _vm._v("Honey Butter")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_vm._v("Makes approximately "), _c('span', {
    staticClass: "numerator cap"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "denom"
  }, [_vm._v("2")]), _vm._v(" cup")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_c('span', {
    staticClass: "numerator"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "denom"
  }, [_vm._v("2")]), _vm._v(" cup unsalted butter, softened")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("1 tablespoon honey")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("Pinch of cinnamon")]), _vm._v(" "), _c('p', {
    staticClass: "direction"
  }, [_vm._v("In a medium bowl, thoroughly combine butter, honey, and cinnamon. Cover and store leftovers in an airtight container and refrigerate for up to 2 months. Butter will last up to 6 months in the freezer.")]), _vm._v(" "), _c('h3', {
    staticClass: "Heading-2"
  }, [_vm._v("Strawberry Butter")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_vm._v("Makes approximately "), _c('span', {
    staticClass: "numerator cap"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "denom"
  }, [_vm._v("2")]), _vm._v(" cup")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_c('span', {
    staticClass: "numerator"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "denom"
  }, [_vm._v("2")]), _vm._v(" cup unsalted butter, softened")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("6 large strawberries, hulled and chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_c('span', {
    staticClass: "numerator"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "denom"
  }, [_vm._v("4")]), _vm._v(" cup powdered sugar")]), _vm._v(" "), _c('p', {
    staticClass: "direction"
  }, [_vm._v("In a medium bowl, thoroughly combine butter, strawberries, and sugar. Cover and store leftovers in an airtight container and refrigerate for up to 2 months. Butter will last up to 6 months in the freezer.")]), _vm._v(" "), _c('h3', {
    staticClass: "Heading-2"
  }, [_vm._v("Lemon-Herb Butter")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_vm._v("Makes approximately "), _c('span', {
    staticClass: "numerator cap"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "denom"
  }, [_vm._v("2")]), _vm._v(" cup")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_c('span', {
    staticClass: "numerator"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "denom"
  }, [_vm._v("2")]), _vm._v(" cup unsalted butter, softened")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_c('span', {
    staticClass: "numerator"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "denom"
  }, [_vm._v("2")]), _vm._v(" teaspoon chopped fresh thyme")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_c('span', {
    staticClass: "numerator"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "denom"
  }, [_vm._v("4")]), _vm._v(" teaspoon chopped fresh rosemary")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_c('span', {
    staticClass: "numerator"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "denom"
  }, [_vm._v("2")]), _vm._v(" teaspoon minced garlic")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_c('span', {
    staticClass: "numerator"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "denom"
  }, [_vm._v("2")]), _vm._v(" teaspoon lemon zest")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient"
  }, [_vm._v("Pinch of kosher salt")]), _vm._v(" "), _c('p', {
    staticClass: "direction"
  }, [_vm._v("In a medium bowl, thoroughly combine butter, herbs, garlic, zest, and salt. Place butter onto a sheet of parchment paper and roll up into the shape of a log. Twist ends close and refrigerate up to 2 months. Butter will last up to 6 months in the freezer.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-87d31f7e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Lets-Brunch-Interiors_D-5.vue
// module id = 75
// module chunks = 0